import { Action as DefaultAction } from 'vuex-module-decorators';
import { ActionDecoratorParams } from 'vuex-module-decorators/dist/types/action.d';

/**
 * Overwrites the default vuex Action decorator and sets "rawError" always to "true".
 */
/* eslint-disable @typescript-eslint/explicit-function-return-type, @typescript-eslint/naming-convention,
	@typescript-eslint/explicit-module-boundary-types */
export function Action<T, R>(
	target: T,
	key: string | symbol,
	descriptor: TypedPropertyDescriptor<(...args: any[]) => R>
): void;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function Action(params: ActionDecoratorParams): MethodDecorator;
export function Action<T, R>(
	targetOrParams: T | ActionDecoratorParams,
	key?: string | symbol,
	descriptor?: TypedPropertyDescriptor<(...args: any[]) => R>
) {
	if (!key && !descriptor) {
		const params: ActionDecoratorParams = (targetOrParams as ActionDecoratorParams) || {};
		params.rawError = true;

		return DefaultAction(params);
	}

	const target: T = targetOrParams as T;

	// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	return DefaultAction({ rawError: true })(target as any, key!, descriptor!);
}

/* eslint-ensable @typescript-eslint/explicit-function-return-type, @typescript-eslint/naming-convention,
	@typescript-eslint/explicit-module-boundary-types */
